import Result from "@/core/common/Result";

export interface IPlainBase64 {
  handlePlainBase64(file: string): Result<string>;
}

export const PlainBase64DI = Symbol("plainbase64");
